'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

const React = require('react');
const React__default = _interopDefault(React);
const ReactDOM = _interopDefault(require('react-dom'));
require('../../node_modules/framer-motion/dist/es/context/MotionConfigContext.js');
require('../../node_modules/framer-motion/dist/es/context/PresenceContext.js');
require('../../node_modules/framer-motion/dist/es/components/AnimatePresence/use-presence.js');
require('../../node_modules/framer-motion/dist/es/context/LayoutGroupContext.js');
require('../../node_modules/framer-motion/dist/es/components/AnimateSharedLayout/types.js');
require('../../node_modules/framer-motion/dist/es/components/AnimateSharedLayout/utils/batcher.js');
require('../../node_modules/framer-motion/dist/es/context/SharedLayoutContext.js');
require('../../node_modules/framer-motion/dist/es/motion/index.js');
require('../../node_modules/framer-motion/dist/es/events/use-dom-event.js');
require('../../node_modules/framer-motion/dist/es/motion/features/drag.js');
require('../../node_modules/framer-motion/dist/es/gestures/use-pan-gesture.js');
require('../../node_modules/framer-motion/dist/es/gestures/use-tap-gesture.js');
require('../../node_modules/framer-motion/dist/es/gestures/use-gestures.js');
require('../../node_modules/framer-motion/dist/es/motion/features/gestures.js');
require('../../node_modules/framer-motion/dist/es/motion/features/exit.js');
require('../../node_modules/framer-motion/dist/es/value/index.js');
require('../../node_modules/framer-motion/dist/es/render/utils/animation.js');
require('../../node_modules/framer-motion/dist/es/animation/animation-controls.js');
require('../../node_modules/framer-motion/dist/es/motion/features/animation.js');
require('../../node_modules/framer-motion/dist/es/motion/features/layout/Animate.js');
require('../../node_modules/framer-motion/dist/es/render/dom/projection/scale-correction.js');
require('../../node_modules/framer-motion/dist/es/motion/utils/valid-prop.js');
require('../../node_modules/framer-motion/dist/es/render/index.js');
require('../../node_modules/framer-motion/dist/es/value/utils/resolve-motion-value.js');
require('../../node_modules/framer-motion/dist/es/render/dom/motion.js');
const index$2 = require('../../node_modules/framer-motion/dist/es/components/AnimatePresence/index.js');
require('../../node_modules/framer-motion/dist/es/animation/animate.js');
require('../../node_modules/framer-motion/dist/es/animation/use-animation.js');

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var Portal = function Portal(_ref) {
  var children = _ref.children,
    container = _ref.container,
    _ref$disablePortal = _ref.disablePortal,
    disablePortal = _ref$disablePortal === void 0 ? false : _ref$disablePortal,
    _ref$isTransitionable = _ref.isTransitionable,
    isTransitionable = _ref$isTransitionable === void 0 ? false : _ref$isTransitionable;
  var _React$useState = React__default.useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    mountNode = _React$useState2[0],
    setMountNode = _React$useState2[1];
  React.useEffect(function () {
    if (!disablePortal) {
      // We don't want to override `null` values here as it may be possible to have
      // some DOM queries or Refs for target container to have initial values as null
      setMountNode(container || container === null ? container : document.body);
    }
  }, [container, disablePortal]);
  var content = isTransitionable ? /*#__PURE__*/React__default.createElement(index$2.AnimatePresence, null, children) : children;
  if (disablePortal) {
    return /*#__PURE__*/React__default.isValidElement(content) ? content : null;
  }
  return mountNode ? /*#__PURE__*/ReactDOM.createPortal(content, mountNode) : null;
};

module.exports = Portal;
